<template>
  <div style="display: flex; gap: 4px; width: 500px; flex-flow: wrap">
    <div
      v-for="(items, k) in showMore ? item.provincelist.slice(0, limitProvince) : item.provincelist"
      :key="k"
    >
      <span style="padding: 0px 8px; border-radius: 6px; border: 1px solid #0C2F53; !important" class="background-lightblue01">
        {{ items }}
      </span>
    </div>
    <div v-if="showMore & (item.provincelist.length > limitProvince)" @click="showMore = false">
      <Typography class="cursor-5" bold h5 label="...ดูเพิ่มเติม" />
    </div>
    <div v-if="!showMore & (item.provincelist.length > limitProvince)" @click="showMore = true">
      <Typography class="cursor-5" bold h5 label="...ย่อ" />
    </div>
  </div>
</template>

<script>
import Typography from '@/components/elements/Typography.vue'

export default {
  props: {
    item: Object,
    showMore: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Typography,
  },
  data() {
    return { limitProvince: 5 }
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/TagsProvinces.vue